import { request } from './axios.js'
export let addIcaurCusApi = (data) =>
  request({ data, url: '/webapp/api/icaurCus/add', })

export let payStripeCusApi = (data) =>
  request({ data, url: '/webapp/api/pay/stripe', })

export let icaurCusUserInfoApi = (data) =>
  request({ data, url: '/webapp/api/icaurCus/userInfo', })
